import Vue from 'vue';
import Vuex from 'vuex';

import { SET_APP_CONFIG, SET_TERMS, SET_AMOUNTS } from './mutations.js';

import app from '../js/app.js';
import modules from './modules/index.js';
import notify from '@/js/helpers/notify.js';
import apiRequest from '@/js/helpers/apiRequest.js';

Vue.use(Vuex);

export default new Vuex.Store({
  modules,

  state: {
    appConfig: {},
    terms: [],
    amounts: [],
  },

  mutations: {
    [SET_APP_CONFIG]: (state, appConfig) => {
      state.appConfig = appConfig;
    },

    [SET_TERMS]: (state, terms) => {
      state.terms = terms;
    },

    [SET_AMOUNTS]: (state, amounts) => {
      state.amounts = amounts;
    },
  },

  actions: {
    async getAppConfig({ commit }) {
      try {
        const res = await apiRequest('config', 'GET', null);

        if (res.error) {
          throw { customeError: res.error };
        }

        commit(SET_APP_CONFIG, res.success);
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          console.error('ERROR: config:', error);
        }
      }
    },

    async getTerms({ commit }) {
      const res = await apiRequest('terms', 'GET', null, false);

      if (res.error) {
        notify({ text: res.error });
        throw { customeError: res.error };
      }

      commit(SET_TERMS, res.success);
    },

    async getAmounts({ commit }) {
      try {
        const res = await apiRequest('pay/amounts', 'GET', null, true);

        if (res.error) {
          throw { customeError: res.error };
        }

        commit(SET_AMOUNTS, res.success);
      } catch (error) {
        if (error.customeError) {
          notify({ text: error.customeError });
        } else {
          console.error(error);
          notify({ text: app.$t(`notify.something_went_wrong`) });
        }
      }
    },
  },
});
